// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__x6F91","filled":"Checkbox_filled__1UQrX","checkmark":"Checkbox_checkmark__UZ7nO","radio":"Checkbox_radio__pk3Wa"};